import { FieldProps, FormFieldsPropsField } from '../../utils/functionsInterfaces'
import { InputsInfosFields } from '../../components/ui/inputs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile, faFileArrowUp, faFilePowerpoint, faGripVertical, faMagnifyingGlass, faTrash } from '@fortawesome/free-solid-svg-icons'
import { LuType } from 'react-icons/lu'
import { ButtonGetPathField } from '../ui/buttons'
import { getPathField } from '../../functions/getPathField'
import { generateJSON } from '../../functions/generateJSON'

export function Field({
  fieldGroupInGroup,
  indexFieldGroupInGroup,
  index,
  field,
  handleRemoveFieldInGroup,
  handleRemoveField,
  form,
  setForm,
  outsideTheGroup,
  isPersonalDetail,
  setButtonSave,
  authorization,
  clientId,
  ambient,
  formId,
  groupId,
  groupUuid,
}: FormFieldsPropsField) {

  const fieldIcon = fieldGroupInGroup.fieldType === 'multiple_files'
    ? { icon: faFileArrowUp, color: '#2563eb', isCustom: false }
    : fieldGroupInGroup.fieldType === 'personal_details'
      ? { icon: faFilePowerpoint, color: '#10b981', isCustom: false }
      : { icon: faFile, color: '#64748b', isCustom: true }

  const fieldUuid = fieldGroupInGroup?.uuid

  const updateFieldInForm = (updater: (field: any) => any) => {
    if (groupUuid != null && fieldUuid != null) {
      setForm((prev: any[]) =>
        prev.map((group: any) =>
          group.uuid === groupUuid
            ? {
                ...group,
                children: (group.children || []).map((f: any) =>
                  f.uuid === fieldUuid ? updater(f) : f
                ),
              }
            : group
        )
      )
    } else if (fieldUuid != null) {
      setForm((prev: any[]) =>
        prev.map((item: any) => (item.uuid === fieldUuid ? updater(item) : item))
      )
    }
  }

  return (
    <div className={`form-field-row ${fieldGroupInGroup.isNew ? 'is-new' : ''}`}>
      <div className="form-field-drag" title="Arraste para reordenar">
        <FontAwesomeIcon icon={faGripVertical} />
      </div>
      <div className="form-field-icon">
        {fieldIcon.isCustom ? (
          <LuType style={{ color: fieldIcon.color }} />
        ) : (
          <FontAwesomeIcon icon={fieldIcon.icon} style={{ color: fieldIcon.color }} />
        )}
      </div>

      <div className="form-field-inputs">
        <div className="form-field-input">
          <span className="form-field-label">ID do Campo</span>
          <InputsInfosFields
            placeholder='Digite o ID do campo'
            value={fieldGroupInGroup.id}
            onChange={(e) => {
              updateFieldInForm((f) => ({ ...f, id: e.target.value }));
            }}
            onBlur={() => {
              setButtonSave(true)
            }}
          />
        </div>

        <div className="form-field-input">
          <span className="form-field-label">Label de Exibição</span>
          <InputsInfosFields
            placeholder='Digite o nome do campo'
            value={fieldGroupInGroup.name}
            onChange={(e) => {
              updateFieldInForm((f) => ({ ...f, name: e.target.value }));
            }}
            onBlur={() => {
              setButtonSave(true)
            }}
          />
        </div>

        <div className="form-field-input">
          <span className="form-field-label">ID Customizado</span>
          <InputsInfosFields
            placeholder='Id do campo customizado'
            value={fieldGroupInGroup.attribute}
            onChange={(e) => {
              updateFieldInForm((f) => ({ ...f, attribute: e.target.value }));
            }}
            onBlur={() => {
              setButtonSave(true)
            }}
          />
        </div>
      </div>

      <div className="form-field-actions">
        <div className="form-field-flag">
          <span title='Campo obrigatório'>*</span>
          <input
            className="form-field-checkbox"
            type='checkbox'
            checked={field.isRequired || false}
            onChange={(e) => {
              updateFieldInForm((f) => ({ ...f, isRequired: e.target.checked }));
            }}
            onBlur={() => {
              setButtonSave(true)
            }}
          />
        </div>

        {!isPersonalDetail && (
          <div className="form-field-flag">
            <span title='Campo para filtro'>
              <FontAwesomeIcon icon={faMagnifyingGlass} size="2xs" />
            </span>
            <input
              className="form-field-checkbox"
              type='checkbox'
              checked={fieldGroupInGroup.isKey || false}
              onChange={(e) => {
                updateFieldInForm((f) => ({ ...f, isKey: e.target.checked }));
              }}
              onBlur={() => {
                setButtonSave(true)
              }}
            />
          </div>
        )}

        <ButtonGetPathField
          onClick={() => {
            const jsonForm = generateJSON(
              undefined,
              false,
              "data",
              "",
              "",
              "",
              "",
              "",
              form
            )
            getPathField(
              field.id,
              clientId,
              ambient,
              formId,
              authorization,
              groupId || '',
              jsonForm
            )
          }}
        />

        <button
          type='button'
          onClick={() => {
            if (outsideTheGroup) {
              handleRemoveField(
                field.uuid?.toString() || '',
                form,
                setForm,
                setButtonSave
              )
            } else {
              handleRemoveFieldInGroup(
                (groupUuid ?? fieldGroupInGroup.uuid) ?? '',
                field.uuid?.toString() || '',
                form,
                setForm,
                (groupUuid ?? fieldGroupInGroup.uuid) ?? '',
                setButtonSave
              )
            }
          }}
          className="header-buttons-fields-remove"
          title='Remover Campo'
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    </div>
  )
}
